import { Component, OnInit } from '@angular/core';
import { AlertService } from '../services/alert.service';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: false
})
export class AlertComponent implements OnInit {

    // Stores which alert IDs are collapsed and which are not. 
    public expanded = {}; // we call it expanded so it defaults to false/collapsed
    //postTypes:  include Alert Carolina and WordPress Alert Types
    public postTypes: string[] = ['Adverse', 'Weather', 'Adverse Weather', 'Weather Event','Crime','Crime Report','Emergency','Server','Server Issue','Timely','Timely Warning','Info']

    constructor(
        public alerts: AlertService,
    ) { }

    ngOnInit() {
    }
}
